import React, {useRef} from "react";
import PopUp from "../../base/popup";
import DeletePopup from "../deletePopup";
import DateFormat from "./dateFormat";
import HoverButton from "../../../components/buttons/HoverButton";

export default function UserCard(props) {

    const user = props.user;
    const deleteConfirmationRef = useRef(null);

    return(
        <div className="large-3 medium-12 cell">
            <div className="user__box user__box--marginless">
                <h3 className="white mar-bot-10">About the user</h3>
                <p className="user__box__details">Name</p>
                <p>{user.name || 'N/A'}</p>
                <p className="user__box__details">Email address</p>
                <p>{user.email}</p>
                <p className="user__box__details">{user.temp ? 'Invite sent' : 'Joined on'}</p>
                <p>{user.temp ? DateFormat.format(user.created_at) : DateFormat.format(user.confirmed_at)}</p>
                {user.temp ?
                    <div className="grid-x max-width-160">
                        <div className="small-6 cell">
                            <div className="user__button disable mar-right-30" onClick={props.resendInvitation}><span
                                className="small-icon bin envelope-send envelope-send--white"/></div>
                            <p className="users__secondary">Resend</p>
                        </div>
                        <div className="small-6 cell" >
                            <div className="user__button disable" onClick={() => {deleteConfirmationRef.current.open()}}><span
                                className="trash-icon"/></div>
                            <p className="users__secondary">Delete</p>
                        </div>
                    </div> : null }
                {props.completed ?
                <HoverButton href={`/group/tests/download/${user.id}`} hrefOpts={{target: '_blank'}}><span className="small-icon download mar-right-10"/>Download report</HoverButton> : null}

            </div>
            <PopUp ref={deleteConfirmationRef} onClose={() => {}}>
                <DeletePopup email={user.email} onDelete={props.deleteUser} onCancel={() => {deleteConfirmationRef.current.close()}} />
            </PopUp>
        </div>
    )

}